import { Component, OnInit } from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import { J } from '@angular/cdk/keycodes';
// import { triggerAsyncId } from 'async_hooks';


@Component({
  selector: 'app-sla-violation-master',
  templateUrl: './sla-violation-master.component.html',
  styleUrls: ['./sla-violation-master.component.css']
})
export class SlaViolationMasterComponent implements OnInit {
  masterName: string;
  description: string;
  clients: any[];
  clientId: number;

  senderTypeObj = [];
  senderTypeObj1 = [];
  selectedType: number;
  selectedTypeValue: number;
  selectedTypeValue1: number;

  respObjectSenderType: any;
  senderValue: string;
  domain :string;
  email :string;
  selectedTypeId: number;
  selectedTypeId1 :number;
  respObjectSenderValue: any;

  displayData: any;
  isError = false;
  errorMessage: string;
  respObject: any;
  totalData: number;
  masterNameObj = [];
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  add = false;
  del = false;
  edit = false;
  view = false;
  private baseFlag: any;
  private userAuth: Subscription;
  private notifier: NotifierService;
  offset: number;

  columnNameSelected: number;
  columnNameObj = [];
  validationValues: string;
  ticketSelected: number;

  ttypes = [];
  ticketTypeId: number;
  ticketType: string;
  ticketTypeSeq: number;
  ticketTypes = [];

  categoryLoaded: boolean;
  cat = [];
  dynamicFields = [];
  priorityType: number;
  users = [];
  userSelected: number;
  keywordVal: String;
  busi_priority_id: number;
  userGroupId: number;
  respObjectSave: any;
  serviceUserName: String;
  serviceUserMail: any;
  serviceUserMobile: any;

  fullKeyword: String;
  ticketTypeEnum: String;
  dataLoaded:boolean;
  selectedIndextab:number;
  tabSelected :string;

  isEmail:boolean;
  AfterMin:any;
  grpLvl:any;
  emailSub:string;
  scheduleType :any;
  scheduleSelected:any;
  firstTime :string;
  secondTime:string;

  firstHr :any;
  firstMin :any ;
  secHr : any;
  secMin : any;
  levelCount:number;
  grpLvls:any;
  grpLvlArr :any;
  scheduleName:string;
    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
    private modalService: NgbModal, notifier: NotifierService) {

      this.notifier = notifier;
      this.messageService.getCellChangeData().subscribe(item => {
          // console.log(item);
        //   console.log(JSON.stringify(item));

          switch (item.type) {
              case 'change':
                  if (!this.messageService.edit) {
                      this.notifier.notify('error', 'You do not have edit permission');
                  } else {
                      if (confirm('Are you sure?')) {  
                          if(item.time_after_violation_minutes === '' || item.receipent_supportgroup_level === '' || item.email_subject === '' ||item.schedule_time ==='' ){
                              this.notifier.notify('error', "Field can not be empty.");
                              return;
                          }
                          if(item.schedule_time !== ''){
                            let scheduleTimes = item.schedule_time.split(',');
                            if(scheduleTimes.length === 2){
                                let firstSceduleTime = scheduleTimes[0];
                                let secondSceduleTime = scheduleTimes[1];
                                firstSceduleTime = firstSceduleTime.split(":");
                                secondSceduleTime = secondSceduleTime.split(":");
                                let firsthr = firstSceduleTime[0];
                                let firstmin = firstSceduleTime[1];
                                let sechr = secondSceduleTime[0];
                                let secmin = secondSceduleTime[1];
                                if(((Number(firsthr) * 60) + Number(firstmin) >= 1440 )||((Number(sechr) * 60) + Number(secmin) >= 1440 ) || (Number(secmin) >= 60 ) || (Number(firstmin) >= 60 ) ){
                                    this.notifier.notify('error', "Invalid Time Value");
                                    return;
                                }
                                 
                            }else{
                               let firstSceduleTime = scheduleTimes[0];
                               firstSceduleTime = firstSceduleTime.split(":");
                               let firsthr = firstSceduleTime[0];
                               let firstmin = firstSceduleTime[1];
                               if(((Number(firsthr) * 60) + Number(firstmin) >=  1440) || (Number(firstmin) >= 60 )) {
                                this.notifier.notify('error', "Invalid Time Value");
                                return;
                               }
                            }


                          }


                          if(item.time_after_violation_minutes !== ''){
                              let key = item.time_after_violation_minutes;
                              try {
                                  key = Number(key);
                                  if(isNaN(key)) throw "Invalid Time after sla violation";

                              } catch (error) {
                                    this.notifier.notify('error', error);
                                    return;
                                  }

                              }
    



                            //   for(let i = 0 ; i<key.length;i++){
                            //       let keyval = key[i];
                            //       let val = keyval.keyCode
                            //       console.log(val);
                            //       if(Number(val) >= 48 && Number(val) <= 57 )

                            //       {
                            //           keyval = 0;
                            //           break;
                            //       }else{
                            //         notNum = true;
                            //         keyval = 0;
                            //       }
                            //       console.log(notNum);

                            //   }
                        
                          


                        //   if(item.receipent_supportgroup_level !== ""){
                        //     let istrue = false;

                        //      let str = item.receipent_supportgroup_level.toUpperCase();
                        //      for(let i = 0 ; i <this.grpLvls.length; i++ ){
                        //         //  console.log("====="+str + "..........."+JSON.stringify(this.grpLvls));

                        //          if(str === this.grpLvls[i].name.toString()){

                        //              item.receipent_supportgroup_level = this.grpLvls[i].id;
                        //              console.log(item.receipent_supportgroup_level);
                        //              istrue = true;
                        //              break;
                        //          }
                        //      }

                        //      if(!istrue){
                        //         this.notifier.notify('error', "Invalid Support Group Level");
                        //         return;

                        //     }
  

                        //   }
  
                          item.createdBy = this.messageService.getUserId();
                          item.client_id = this.clientId;
                          console.log(JSON.stringify(item));
                          this._rest.updateSlaViolationMaster(item).subscribe((res) => {
                              this.respObject = res;
                              if (this.respObject.success) {
                                  // console.log('data--Done');
                                  this.notifier.notify('success', 'Updated successfully');
                                  this.onPageLoad();
                              } else {
                                  // console.log('data--Not---Done');
                                  this.notifier.notify('error', this.respObject.errorMessage);
                              }
                          }, (err) => {
                              this.notifier.notify('error', JSON.stringify(err));
                          });
                      }
                  }
                  break;
              case 'delete':
                  // console.log('deleted');
                  if (!this.messageService.del) {
                      this.notifier.notify('error', 'You do not have delete permission');
                  } else {
                      if (confirm('Are you sure?')) {
                          // console.log(JSON.stringify(item));
                          this._rest.deleteSedularConfig({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                              this.respObject = res;
                              if (this.respObject.success) {
                                  // this.totalData = this.totalData - 1;
                                  // this.messageService.setTotalData(this.totalData);
                                  this.messageService.sendAfterDelete(item.id);
                              } else {
                                  this.notifier.notify('error', this.respObject.errorMessage);
                              }
                          }, (err) => {
                              this.notifier.notify('error', JSON.stringify(err));
                          });
                      }
                  }
                  break;
          }
      });
  }
  
     

  ngOnInit() {
    this.dataLoaded=false;
    this.grpLvl = '';
    this.AfterMin = '' ;
    this.emailSub = "";

    // this.ticketSelected = 0;
    // this.selectedIndextab = -1 ; 
    // this.selectedType = 0;
    // this.senderValue = "";
    // this.domain = "";
    // this.email = "";
    // this.selectedTypeId = 0;
    // this.selectedTypeId1 = 0;
    // this.isEmail = false;

    // this.keywordVal = "";
   
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
        pageName: 'Maintain SLA Violation Config',
        openModalButton: 'Add SLA Violation Config',
        breadcrumb: '',
        folderName: '',
        tabName: ''
    };

    const columnDefinitions = [
        {
            id: 'delete',
            field: 'id',
            excludeFromHeaderMenu: true,
            formatter: Formatters.deleteIcon,
            minWidth: 30,
            maxWidth: 30,
        },
        // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
        // {
        //     id: 'sender_type_name', name: 'Sender Type', field: 'sender_type_name', sortable: true, filterable: true
        // },
        {
          id: 'time_after_violation_minutes', name: 'Time After Violation(Min)', field: 'time_after_violation_minutes', sortable: true, filterable: true,
          cssClass: 'highlight', 
          editor: {
            model: CustomInputEditor,
        }


        },
        {
            id: 'receipent_supportgroup_level', name: 'Support Group Level', field: 'receipent_supportgroup_level', sortable: true, filterable: true,
        //     cssClass: 'highlight', 
        //     editor: {
        //       model: CustomInputEditor,
        //   }
  
          },
        {
          id: 'email_subject', name: 'Email Subject', field: 'email_subject', sortable: true, filterable: true,
          cssClass: 'highlight', 
          editor: {
            model: CustomInputEditor,
        }

        },
        {
            id: 'schedule_type', name: 'Schedule Type', field: 'schedule_type', sortable: true, filterable: true
  
        },
        {
            id: 'schedule_time', name: 'Schedule Time', field: 'schedule_time', sortable: true, filterable: true,
            cssClass: 'highlight', 
            editor: {
              model: CustomInputEditor,
          }
  
        },
    
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
        this.clientId = this.messageService.clientId;
        this.baseFlag = this.messageService.baseFlag;
        this.onPageLoad();
    } else {
        this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
            this.view = auth[0].viewFlag;
            this.add = auth[0].addFlag;
            this.edit = auth[0].editFlag;
            this.del = auth[0].deleteFlag;
            this.clientId = auth[0].clientId;
            this.baseFlag = auth[0].baseFlag;
            this.onPageLoad();
        });
    }



  }
  onPageLoad(){
       this.grpLvls = [];

        this.scheduleType = [{"id":0,"name":"Select Sedule Type"} ,{"id":1,"name":"Daily"}];
        this.grpLvlArr = [{"id":1,"name":"L1"}, {"id":2,"name":"L2"},{"id":3,"name":"L3"},{"id":4,"name":"L4"},{"id":5,"name":"L5"}, {"id":6,"name":"L6"},{"id":7,"name":"L7"}, {"id":8,"name":"L8"},{"id":9,"name":"L9"}]


        // this.ticketSelected = 0;
        // this.userSelected = 0;
        // this.senderValue = "";
        // this.domain = "";
        // this.email = "";
        // this.keywordVal = "";
        // this.ticketTypeEnum = "";



        this.grpLvl = '';
        this.AfterMin = '' ;
        this.emailSub = "";
        this.firstTime = "";
        this.secondTime = "";
        this.scheduleSelected = 0;



        this._rest.getSupportGroupCount(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.levelCount = this.respObject.details;
                console.log("++++++"+this.levelCount) ;

              for(let i = 0 ; i <this.levelCount-1 ; i++){
                  this.grpLvls.push(this.grpLvlArr[i]);

              }

            } else {
                this.isError = true;
                this.errorMessage = this.respObjectSave.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });

    

    
    
        

        this.getTableData();
    }
    

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            // this.masterName = '';
            // this.description = '';
            // this.errorMessage = '';
            // this.columnNameObj = [];
            // this.columnNameSelected = 0;
            // this.userSelected = 0;
            // this.busi_priority_id = 0;
            // this.userGroupId = 0;
            // this.keywordVal = '';
            // this.senderValue = "";
            // this.domain = "";
            // this.email = "";
            // this.serviceUserName = "";
            // this.serviceUserMail = "";
            // this.serviceUserMobile = "";



            this.grpLvl = '';
            this.AfterMin = '' ;
            this.emailSub = "";
            this.firstTime = "";
            this.secondTime = "" ;
            this.scheduleSelected = 0;
            this.isError = false;

        
        
            this.modalService.open(content).result.then((result) => {
            }, (reason) => {

            });
        }
    }


    tabClick(event){
    // console.log("........."+event.tab.textLabel)
    this.tabSelected = "" +event.tab.textLabel;
    if(this.tabSelected === "Email Config"){
        this.isEmail = true;
    }else{
       this.isEmail = false;

    }
}


onSeduleChange(selectedIndex: any){
  this.scheduleSelected = this.scheduleType[selectedIndex].id;
  this.scheduleName = this.scheduleType[selectedIndex].name;
  

}

save() {
let firstTimes = this.timeFormat(this.firstTime);
let secondTimes = this.timeFormat(this.secondTime);
let timeDifference = false ;
let totalTime ="" ;
if(secondTimes !== "00:00"){
 timeDifference = this.diff_hours(this.firstTime , this.secondTime);

  totalTime = firstTimes +","+secondTimes;


}else{
  totalTime = firstTimes ;
}


const data = {
client_id :this.clientId,
schedule_type :this.scheduleName,
schedule_time :totalTime


}
        console.log('data before====' + JSON.stringify(data));
        if (!this.messageService.isBlankField(data) && (firstTimes !== "00:00") && (this.scheduleSelected !== 0)){

            if(!timeDifference){

            this._rest.insertSedularConfig(data).subscribe((res1) => {
                this.respObjectSave = res1;
                if (this.respObjectSave.success) {
                this.onPageLoad();
                alert("Please Configure receipent");
                this.scheduleSelected = 0;
                this.firstTime = "";
                this.secondTime = "";
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObjectSave.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });


          }else{
            this.isError = true;
            this.errorMessage = "Time difference should be minimum 2 hour";



          }


        }
        else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
        

    }

diff_hours(dt1, dt2) {
        dt1 = new Date(dt1);
        dt2 = new Date(dt2);
        let isDiff ;
 if(dt2.getTime() >= dt1.getTime()){
    var diff =(dt2.getTime() - dt1.getTime()) / 1000;

}else{
    var diff =(dt1.getTime() - dt2.getTime()) / 1000;

}

  diff /= (60 * 60);

  if(Math.abs(Math.floor(diff)) >= 2 ){
     isDiff = false;
  }else{
      isDiff = true;
  }
  
  return (isDiff);
  
 }


//   timeDiff(time1 , time2){
//     let first = time1.split(":");
//     let firstHr = first[0] ;
//     let firstMin = first[1] ;
  
//     let second = time2.split(":");
  
//     let secHr = second[0];
//     let secMin = second[1];
//      let time_diff = (Number(secHr) - Number(firstHr))

//     if (time_diff < 0) {
//         time_diff = 24 + time_diff;
//      }

//      let isDiff ;

//   if( time2 !== "00:00"){
//      if(time_diff < 2 ){
//         isDiff = true;
//      }else if ( time_diff = 2){
//          if(secMin >= firstMin){
//              isDiff = false;
//          }else{
//              isDiff = true ;
//          }

//      }else if(time_diff > 2){
//          isDiff =false;
//      }

//     }else{
//         isDiff =false;

//     }

//      return isDiff ;
    
//   }

    submit(){
      
      const data = {
        client_id :this.clientId,
        supportgrplevel: Number(this.grpLvl),
        violation_min: Number(this.AfterMin),
        email_sub:this.emailSub
       
       
       }
       
        // console.log("dataaa" + JSON.stringify(data));

        if (!this.messageService.isBlankField(data) ){

            this._rest.insertEmailConfig(data).subscribe((res1) => {
                this.respObjectSave = res1;
                if (this.respObjectSave.success) {
                this.onPageLoad();
                alert("Added successfully");
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObjectSave.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        }
        else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
        

    }

    blockSpecialChar(e){

        const k = e.keyCode;
        return ( k >= 48 && k <= 57);


    }




    timeFormat(date) {
      // console.log(date);
      if (date !== null && date !== 0 && date !== undefined && date !== "") {
          const d = new Date(date);
          const hour = d.getHours();
          const min = d.getMinutes();
          // console.log('utc min' + min);
          let nHour, nMin;
          if (hour < 10) {
              nHour = '0' + hour;
          } else {
              nHour = hour;
          }
          if (min < 10) {
              nMin = '0' + min;
          } else {
              nMin = min;
          }
          return nHour + ':' + nMin;
      } else {
          return '00:00';
      }
  }

    

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getSlaViolationMaster(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            for(let i = 0 ;i<this.respObject.details.dataObj.length ; i++){
            
                  for(let j = 0 ; j<this.grpLvlArr.length ; j++){            
                      if(this.respObject.details.dataObj[i].receipent_supportgroup_level === this.grpLvlArr[j].id.toString()){
                        this.respObject.details.dataObj[i].receipent_supportgroup_level = this.grpLvlArr[j].name;
                        break;
                      }
                  }
            }
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    // onTypeChange() {
    //   const data = {
    //       client_id: this.clientId,
    //       type: this.selectedTypeValue
    //   };
    //     console.log(this.selectedTypeValue);
    //     this._rest.editEmailTicketSenderType(data).subscribe((res1) => {
    //       this.respObjectSenderType = res1;
    //       if (this.respObjectSenderType.success) {
    //         this.onPageLoad();
    //         alert("Updated successfully");
    //       } else {
    //           this.notifier.notify('error', this.respObjectSenderType.errorMessage);
    //       }
    //   }, (err) => {
    //       this.notifier.notify('error', this.messageService.SERVER_ERROR);
    //   });
    // }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }
  

  


}
